












import { TranslateResult }            from 'vue-i18n';
import { computed, defineComponent }  from '@vue/composition-api';
import { Computed }                   from '@/types';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import { SettingsItem }               from '@/views/settings/types/types';
import { getViewStorePath }           from '@/store/store.helpers';
import cBreadcrumb                    from '@/components/breadcrumb/breadcrumb.component.vue';
import cSettingsListItem              from './components/settings-list-item.component.vue';
import { name }                       from './settings.route';

export default defineComponent({
  name: 'vSettings',
  components: {
    cBreadcrumb,
    cSettingsListItem,
  },
  setup() {
    const { i18n, store }: GlobalContexts = useGlobals();

    store.dispatch(`${getViewStorePath(name)}/checkRateChecker`);
    const breadcrumbTranslation: Computed<TranslateResult> = computed(() => i18n.t('vSettings.breadcrumb'));

    const settingsList: Computed<SettingsItem[]> = computed(() => store.getters[ `${getViewStorePath(name)}/getSettingsList` ] as SettingsItem[]);
    return {
      breadcrumbTranslation,
      settingsList,
    };
  },
});
